export const ROLE_CHANNEL_PARTNER = "role::channel_partner";